export const waitForCheckoutSDK = async (maxAttempts = 20, delayMs = 250): Promise<boolean> => {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    if ((window as any).Checkout) {
      return true;
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  return false;
};

export const waitForElement = async (selector: string, maxAttempts = 50, delayMs = 100): Promise<Element> => {
  let attempt = 0;
  while (attempt < maxAttempts) {
    const element = document.querySelector(selector);
    if (element) {
      return element;
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
    attempt++;
  }
  throw new Error(`Element "${selector}" not found after ${maxAttempts} attempts.`);
};

export type PeachCheckoutEvent = {
  amount: number;
  checkoutId: string;
  currency: string;
  merchantTransactionId: string;
  paymentType: 'DB' | 'PA';
  result: {
    code: string;
    description: string;
  };
  signature: string;
  timestamp: Date;
};

export type PeachCompletedCheckoutEvent = PeachCheckoutEvent & {
  // RegistrationId is not present on the peach docs but we do receive it as part of the completed event payload.
  // It is only present when the user opts to save their card and is used to store the card token for future payments.
  registrationId?: string;
  merchant: {
    name: string;
  };
  paymentBrand: string;
  resultDetails: {
    AcquirerResponse: string;
    ConnectorTxID1: string;
    ExtendedDescription: string;
  };
};

export type PeachExpiredCheckoutEvent = PeachCheckoutEvent & {
  id: string;
};

export type PeachErrorCheckoutEvent = {
  result: {
    code: string;
    description: string;
  };
};
